module.exports = __webpack_public_path__ + "img/behance.53919ec8.png";